import { BrowserRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

class EventedBrowserRouter extends BrowserRouter {
  static propTypes = {
    basename: PropTypes.string,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node,
    onLocationChange: PropTypes.func,
  }

  constructor(props) {
    super(props)

    // console.log('EventedBrowserRouter.history', this.history)
    this.history.listen(this.onLocationChange.bind(this))
    this.onLocationChange(this.history.location)
  }

  onLocationChange(nativeLocation) {
    // console.log('EventedBrowserRouter.onLocationChange', nativeLocation)
    const location = {
      ...nativeLocation,
      pathname: this.props.basename + nativeLocation.pathname,
    }
    if (this.props.onLocationChange) {
      // console.log('EventedBrowserRouter.props.onLocationChange', location)
      this.props.onLocationChange(location)
    }
  }
}

export default EventedBrowserRouter
